module.exports = __webpack_public_path__ + "img/tagDpoLab.d14752bd.svg";